const fetchSourceHeaders = (
    source?: string
):
    | {
          headers: {
              'X-Req-Source': string;
          };
      }
    | undefined => {
    return source && source === 'BookWithMe'
        ? {
              headers: {
                  'X-Req-Source': 'BookWithMe',
              },
          }
        : undefined;
};

export default fetchSourceHeaders;
